import { Customer } from "@hydrologiq/gql-experience/graphql"
import CustomerRunDryIcon from "./CustomerRunDryIcon"

interface CustomerRunDryProps {
  customer: Customer
}

function CustomerRunDry({ customer }: CustomerRunDryProps) {
  return <CustomerRunDryIcon customer={customer} />
}

export default CustomerRunDry
